import { useMutation } from "@tanstack/react-query";
import { putMonitoringCheck } from "../api/detect";
import { useQueryClient } from "@tanstack/react-query";

export const usePutMonitoringCheck = (event_seq: number) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: () => putMonitoringCheck(event_seq),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["DetectLive"] });
    },
  });
  return mutation;
};
